import {observer} from "mobx-react";
import "./TableauBlanc.scss";
import {useStores} from "../../../stores/Context";
import SidebarWidgets from "../../SidebarWidgets/SidebarWidgets";
import React, {useState} from "react";
import BtnSvg from "../../../boiteAOutils/BtnSvg";
import CorbeilleSvg from "../../../boiteAOutils/SVG/CorbeilleSvg";
import CrayonSvg from "../../../boiteAOutils/SVG/CrayonSvg";
import WidgetTableauBlancSvg from "../../../boiteAOutils/SVG/TypeWidget/WidgetTableauBlancSvg";


const CanvaListe = observer(() => {
    const {TableauBlancStore, widgetStore} = useStores();
    
    const [showActions, setShowActions] = useState(null);
    const [renamingId, setRenamingId] = useState(null);
    const [newName, setNewName] = useState("");

    const cookieEntreprise = widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();
    TableauBlancStore.hasBibliothequeImages = Array.isArray(entrepriseInfos.phidgetsActives) && entrepriseInfos.phidgetsActives.includes("WidgetBibliothequeImages");

    const handleRename = (id) => {
        TableauBlancStore.renameCanvas(id, newName);
        setRenamingId(null);
        setNewName("");
    };


    return (
        <div className={"contenantEntier"} style={{gap: "24px"}}>
            <SidebarWidgets widget={"TableauBlanc"}></SidebarWidgets>

            <div className={"enTeteTableauBlanc"}>
                <div className={"nomPhiddget"}>Tableau Blanc</div>
                <div className={"titreTableauBlanc"}>{TableauBlancStore.tb_nom} - Liste des tableaux</div>
            </div>

            {TableauBlancStore.listeCanvas && TableauBlancStore.listeCanvas.length > 0 && (
                <>
                    <div style={{padding: "0 20px"}}>
                        <button type="button" className="canvaQuickCreate" onClick={() => TableauBlancStore.createCanvas()}>
                            <span aria-hidden="true">+</span> Ajouter un tableau
                        </button>
                    </div>

                </>
            )}

            <div>
                {TableauBlancStore.listeCanvas && TableauBlancStore.listeCanvas.length > 0 && (
                    <div className={"listeDesTableaux"}>Liste des tableaux</div>
                )}
                <div className={"listeCanvas"}>
                    {TableauBlancStore.listeCanvas && TableauBlancStore.listeCanvas.length > 0 ? (
                        TableauBlancStore.listeCanvas.map((canva, index) => {
                            return (
                                <div key={index} className={"lienCanva"}>
                                    <div className={"canvaActions"}>
                                        {(TableauBlancStore.canvaEpingle === canva.id_canva) ? (
                                            <BtnSvg svg={"ancrage"} width="28" height="38"
                                                    onClick={() => {
                                                    }}/>
                                        ) : (
                                            <BtnSvg svg={"ancrage"} width="28" height="38" couleur={"#A8B0B3"}
                                                    onClick={() => TableauBlancStore.epinglerCanvas(canva.id_canva)}/>
                                        )}

                                        <BtnSvg svg={"trois_points"} height={"40"} width={"40"}
                                                onClick={() => setShowActions(canva.id_canva)}/>


                                        {(showActions === canva.id_canva) && (
                                            <div className={"consigneCardContentActionsContent"}>
                                                <div className={"consigneCardContentActionsItems"}
                                                     onClick={() => {
                                                         setRenamingId(canva.id_canva);
                                                         setNewName(canva.canva_nom);
                                                         setShowActions(null);
                                                     }}>
                                                    <CrayonSvg/> Renommer
                                                </div>
                                                <div className={"consigneCardContentActionsItems"}
                                                     onClick={() => TableauBlancStore.dupliquerCanvas(canva.id_canva)}>
                                                    <CrayonSvg/> Dupliquer
                                                </div>
                                            </div>
                                        )}

                                    </div>

                                    {renamingId === canva.id_canva ? (
                                        <input className="form-control" value={newName}
                                               onChange={(e) => setNewName(e.target.value)}
                                               onBlur={() => handleRename(canva.id_canva)}
                                               autoFocus
                                        />
                                    ) : (
                                        <div className="canva_nom">
                                            {canva.canva_nom}
                                        </div>
                                    )}

                                    <div className={"canvaPrevisualisation"}
                                         onClick={() => (TableauBlancStore.idCanvas = canva.id_canva)}>
                                        <img
                                            src={process.env.REACT_APP_API_URL + "/storage/tableau_blanc/tableau_blanc_" + canva.id_canva + ".png?" + new Date().getTime()}
                                            alt="Aperçu du tableau blanc"
                                            onError={(e) => {
                                                e.target.style.display = "none";
                                            }}
                                        />
                                    </div>

                                    <div className={"ligne"}></div>

                                    <div className={"derniere_ligne"}>
                                        <div className={"date_creation"}>Ajouté
                                            le {new Date(canva.created_at).toLocaleString("fr-FR", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit"
                                            })}</div>

                                        <div className={"corbeille"}
                                             onClick={() => TableauBlancStore.deleteCanvas(canva.id_canva)}>
                                            <CorbeilleSvg/>
                                        </div>
                                    </div>
                                </div>
                            );
                        })) : (
                        <div className={"messageAucunTableau"}>
                            <div>
                                <WidgetTableauBlancSvg width={"40px"} height={"40px"} couleur={"#002335"}/>
                            </div>
                            <div>
                                Aucun tableau blanc actuellement.
                            </div>
                            <div>
                                <button type="button" className="canvaQuickCreate isEmptyState" onClick={() => TableauBlancStore.createCanvas()}>
                                    + Créer un nouveau tableau
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default CanvaListe;
